<div class="assistant-card">
  <header class="assistant-header">
    <div class="signal-dot" [class.active]="isLoading()"></div>
    <div class="header-text">
      <h2>Pitaj Mapsy AI</h2>
      <p>Postavi pitanje o svojim vožnjama</p>
    </div>
  </header>

  <div class="messages-viewport">
    @if (messages().length === 0) {
      <div class="empty-state">
        <p class="empty-hint">Na primjer:</p>
        <div class="prompt-chips">
          @for (prompt of suggestedPrompts; track prompt) {
            <button class="prompt-chip" type="button" (click)="sendMessage(prompt)">
              {{ prompt }}
            </button>
          }
        </div>
      </div>
    } @else {
      <div class="messages-list">
        <div class="route-line"></div>

        @for (message of messages(); track message.timestamp) {
          <div class="message-row" [class.user]="message.role === 'user'">
            <div class="waypoint-node" [class.user]="message.role === 'user'"></div>
            <div class="bubble" [class.user]="message.role === 'user'">
              <div class="bubble-content" [innerHTML]="renderMarkdown(message.content)"></div>
              <span class="timestamp">{{ message.timestamp | date: 'HH:mm' }}</span>
            </div>
          </div>
        }

        @if (isLoading()) {
          <div class="message-row">
            <div class="waypoint-node pulse"></div>
            <div class="bubble typing">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </div>
          </div>
        }
      </div>
    }
    <div #messagesEnd></div>
  </div>

  <div class="input-bar">
    <textarea
      #promptInput
      class="input-field"
      rows="1"
      placeholder="Pitaj o svojim vožnjama..."
      [ngModel]="inputValue()"
      (ngModelChange)="inputValue.set($event)"
      (input)="resizePromptInput()"
      (keydown)="onKeydown($event)"
    ></textarea>
    <button
      class="send-btn"
      type="button"
      (click)="sendMessage()"
      [disabled]="!inputValue().trim() || isLoading()"
      aria-label="Pošalji poruku"
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4 12L20 4L14 20L11 13L4 12Z"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</div>